import styled from '@eduzz/houston-styles';

export const Container = styled.div<{ bgColor?: string }>`
  background-color: ${({ bgColor, theme }) => (!!bgColor ? bgColor : theme.brandColor.primary.pure)};
  color: #fff;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  width: 62px;
  height: 22px;
  font-size: 0.75rem;
  line-height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -6px;
  right: 3px;
`;
